import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[sharedTable]',
})
export class SharedTableDirective {
  @Input() sharedTable: string;
  constructor(public readonly template: TemplateRef<any>) {}
}
